module.exports = __webpack_public_path__ + "img/518.4cabc9d6.jpg";